






















































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import DocumentControls from '../../Shared/DocumentControls.vue';
import { CREATE_INVOICE } from '@/queries/Invoice';
import { GQL_newInvoiceData_newInvoice } from '../../../../queries/__generated__/newInvoiceData';
import { GQL_createInvoiceVariables, GQL_createInvoice } from '@/queries/__generated__/createInvoice';
import InvoiceSupplierPartyPicker from './InvoiceSupplierPartyPicker.vue';
import InvoiceCustomerPartyPicker from './InvoiceCustomerPartyPicker.vue';
import InvoiceDeliveryPicker from './InvoiceDeliveryPicker.vue';
import Invoice from '../Invoice.vue';
import { SmartQuery } from 'vue-apollo-decorator';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitInvoiceSetting, GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting } from '@/queries/__generated__/unitInvoiceSetting';

@Component({
  components: {
    DocumentControls,
    InvoiceSupplierPartyPicker,
    InvoiceCustomerPartyPicker,
    InvoiceDeliveryPicker,
    InvoicePaymentMethodForm: () => import('@/components/Invoicing/Invoice/InvoicePaymentMethod/InvoicePaymentMethodForm.vue'),
  },
})
export default class InvoiceNewControls extends Vue {
  public CREATE_INVOICE = CREATE_INVOICE;

  @Prop(Object) public invoice!: GQL_newInvoiceData_newInvoice;
  @Prop(Boolean) public validForm!: boolean;
  @Prop(Object) public invoiceRef!: Invoice;

  @PropSync('valid', { type: Boolean, default: true }) private validInvoicePaymentMethodsForm!: boolean;

  @SmartQuery<InvoiceNewControls, GQL_unitInvoiceSetting>({
    query: () => UNIT_INVOICE_SETTINGS,
    update: (data) => data.currentUnit.unitSetting.unitInvoiceSetting,
  }) private unitInvoiceSetting!: GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting;

  private attachments: File[] = [];
  // these are the only types allowed on EHF XML by Peppol
  // https://docs.peppol.eu/poacc/billing/3.0/rules/ubl-tc434/BR-CL-24/
  // https://docs.peppol.eu/poacc/billing/3.0/rules/PEPPOL-EN16931-CL001/
  private allowedContentTypes = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.oasis.opendocument.spreadsheet',
  ]

  private get hasValidIssueDate(): boolean {
    return !!this.invoice.issueDate && this.$dayjs.strict(this.invoice.issueDate).isValid();
  }

  private formatData(): GQL_createInvoiceVariables {
    return {
      orderIds: this.invoice.orders.map(o => o.id),
      issueDate: this.invoice.issueDate,
      dueDate: this.invoice.dueDate,
      paymentTerm: this.invoice.paymentTerm,
      supplierPartyId: this.invoice.supplierParty.id,
      customerPartyId: this.invoice.customerParty.id,
      orderDeliveryId: this.invoice.orderDelivery.id,
      invoicePaymentMethods: this.invoice.invoicePaymentMethods
        .filter(pm => !pm.amount.isZero())
        .map(pm => {
          return {
            name: pm.name,
            amount: pm.amount,
          };
        }),
      payableRoundingAmount: this.invoice.payableRoundingAmount,
      payableAmount: this.invoice.payableAmount,
      legalNotes: this.invoice.legalNotes,
      customNote: this.invoice.customNote,
      attachments: this.attachments,
    };
  }

  public invoiceCreated({ data }: { data: GQL_createInvoice }) {
    if (!data.createInvoice || !data.createInvoice.invoice) return;

    this.resetFormDirty();

    this.$sMessage.success('Successfully saved.');
    this.$router.push({
      name: 'InvoicesShow',
      params: { id: String(data.createInvoice.invoice.id) },
      query: { created: 'true' },
    });
  }

  private resetFormDirty() {
    this.invoiceRef && this.invoiceRef.formRef && this.invoiceRef.formRef.resetDirty();
  }
}
